import { useAuthContext } from '../../hooks';
import React, { createContext, useEffect, useState } from 'react';
import { getBalanceApi } from '../../services/user/user.api';
import { appConfig } from '../../constants/config';

const AdminBalanceContext = createContext<IAdminBalanceContext>({
  loading: true,
});

export interface IAdminBalanceContext {
  credits?: {
    schoolStuff: {
      credits: number;
    };
    schoolTeacher: {
      credits: number;
    };
  };
  loading: boolean;
  getBalanceCount?: () => void;
}

interface AdminBalanceProviderProps {
  children: React.ReactNode;
}

function AdminBalanceProvider({ children }: AdminBalanceProviderProps) {
  const [loading, setLoading] = useState(true);
  const [balance, setBalance] = useState<any>();
  const { isAuthenticated, user } = useAuthContext();

  async function getBalanceCount() {
    setLoading(true);
    try {
      const res = await getBalanceApi();
      setBalance(res?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const TIME_MINUTES = 3;
    let intervalId: NodeJS.Timer;
    if (isAuthenticated() && user && user.role !== appConfig.role.ADMIN) {
      getBalanceCount();
      intervalId = setInterval(() => {
        getBalanceCount();
      }, TIME_MINUTES * 1000 * 60);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isAuthenticated, user]);

  return (
    <AdminBalanceContext.Provider
      value={{
        loading: loading,
        credits: balance,
        getBalanceCount,
      }}
    >
      {children}
    </AdminBalanceContext.Provider>
  );
}

export { AdminBalanceContext, AdminBalanceProvider };
